import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material';
import { InputParameter } from '../components/entities/InputParameters';


@Injectable()
export class VernostService {
  projectPath: string = "http://localhost:8086";
  constructor(private http: HttpClient, public snackBar: MatSnackBar) {

  }

  getData(url: string) {
    console.log(url);

    return this.http.get(this.projectPath + url);
  }

  postData(url: string, query: any) {
    var params = query;
    var headers = new HttpHeaders();

    console.log(query);
    console.log(url)

    headers.append("Content-Type", "text/plain")

    return this.http.post(this.projectPath + url, params, { headers: headers });
    // .pipe(map( res => res.json()));
  }

  setClearComponents(Fields: any[]) {
    if (Fields != undefined) {
      if (Fields != null) {
        Fields.forEach(element => {
          element.value = undefined;
        });
      }
    }
  }

  setinit(component: InputParameter) {
    if (component.compname === 'combobox') {
      if (component.combo_search_query != undefined) {
        if (component.combo_search_query != "") {
          this.postData("/executequery", { data: btoa(component.combo_search_query) }).subscribe((data: any) => {
            data.forEach((element: any) => {
              component.datavalues.push({ pname: element[component.combo_disp_field], pvalue: data[component.combo_value_field] })
            });
          });
        }
      }
    }
  }

  setReadonlyComponents(readonly: boolean, Fields: any[]) {
    if (Fields != undefined) {
      if (Fields != null) {
        Fields.forEach(element => {
          element.readonly = readonly;
          element.isvalid = true;
        });
      }
    }
  }
  setDisabledComponents(disable: boolean, Fields: any[]) {
    if (Fields != undefined) {
      if (Fields != null) {
        Fields.forEach(element => {
          element.disable = disable;
        });
      }
    }
  }

  addClick(Fields: any[]) {
    if (Fields != undefined) {
      if (Fields != null) {
        Fields.forEach(element => {
          element.isvalid = true;
        });
      }
    }
  }

  editClick(Fields: any[]) {
    if (Fields != undefined) {
      if (Fields != null) {
        Fields.forEach(element => {
          if (element.allowedit == false) {
            element.disable = true;
          }
        });
      }
    }
  }

  saveScreenData(Screen: any) {
    console.log(Screen);
    return new Promise((resolve, reject) => {
      let tableinfo: any = {
        tablename: Screen.table,
        keyid: Screen.key_id,
        keyvalue: Screen.key_value,
        fields: {}
      }
      Screen.fields.forEach((element: any) => {
        tableinfo.fields[element.dbfield] = element.value;
      });
      console.log("tableinfo:", tableinfo);
      this.postData('/adddata', { "data": btoa(JSON.stringify(tableinfo)), "token": localStorage.getItem('userToken') }).subscribe((response) => {
        resolve(response);
      });
    });
  }

  checkValidation(Fields: any[]) {
    let counter: number = 0;
    Fields.forEach(element => {
      if (element.mandatory) {
        if (this.checkUndefined(element.value) == "") {
          element.isvalid = false;
          counter++;
        }
      }
      if (element.isvalid == false) {
        counter++;
      }
    });
    if (counter == 0) {
      return true;
    } else {
      return false;
    }
  }

  checkUndefined(value: any) {
    if (value == null) {
      value = "";
    }
    if (value == undefined) {
      value = "";
    }
    return value;
  }

  showmessaage(message: string) {
    let systemmessage: any = document.getElementById("systemmessage");
    if (systemmessage == null) {
      systemmessage = document.createElement("div");
      systemmessage.setAttribute("style", "position: fixed;bottom: 0;z-index: 9999;right: 0;border-bottom-color: #2fa7fb;border-bottom-style: solid;margin-right: -50%;padding-left: 30px;padding-right: 30px;padding-top: 10px;padding-bottom: 10px;background-color: black;color: white;text-align: center;");
      systemmessage.setAttribute("id", "systemmessage");
      systemmessage.innerHTML = message;
      document.body.appendChild(systemmessage);
    } else {
      systemmessage.innerHTML = message;
    }
    var x = setInterval(function () {
      try {
        systemmessage.parentNode.removeChild(systemmessage);
      } catch (e) {
        console.log(e);
      }
      clearInterval(x);
    }, 2000)
  }
  showprogressmodel() {
    let systemprogress: any = document.getElementById("systemprogress");
    if (systemprogress == null) {
      systemprogress = document.createElement("div");
      systemprogress.setAttribute("class", "processmodal");
      systemprogress.setAttribute("id", "systemprogress");

      let tmpdiv: any = document.createElement("div");
      tmpdiv.setAttribute("class", "processmodal-content");
      tmpdiv.setAttribute("style", "text-align: center;");
      tmpdiv.innerHTML = "<h1>Loading...</h1><br><h6>Please wait</h6>";
      systemprogress.appendChild(tmpdiv);

      document.body.appendChild(systemprogress);
    }
  }
  hideprogressmodel() {
    let systemprogress: any = document.getElementById("systemprogress");
    if (systemprogress != null) {
      systemprogress.parentNode.removeChild(systemprogress);
    }
  }
}